import React, { useState } from "react";
import { parseLocalDate } from "utils/dateUtil";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import { IconButton, Chip } from "@mui/material";
import {
  Edit,
  Delete,
  Schedule,
  Done as CheckCircle,
  Pending as PendingActions,
} from "components/icons";

const getStatusColor = (status) => {
  const colors = {
    SCHEDULED: "info",
    IN_PROGRESS: "warning",
    COMPLETED: "success",
    CANCELLED: "error",
    PENDING_REVIEW: "secondary",
  };
  return colors[status] || "default";
};

const getStatusIcon = (status) => {
  switch (status) {
    case "SCHEDULED": return <Schedule />;
    case "COMPLETED": return <CheckCircle />;
    case "PENDING_REVIEW": return <PendingActions />;
    default: return null;
  }
};

export const AuditDataGrid = ({ audits, isLoading, onEdit, onDelete, showActions = true }) => {
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    ...(showActions ? [{
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: (params) => [
        <IconButton key="edit" onClick={() => onEdit(params.row)} color="primary" size="small">
          <Edit />
        </IconButton>,
        <IconButton key="delete" onClick={() => onDelete(params.row)} color="error" size="small">
          <Delete />
        </IconButton>,
      ],
    }] : []),
    { field: "id", headerName: "ID", width: 80 },
    { field: "auditCode", headerName: "Code", width: 120 },
    { field: "auditTitle", headerName: "Audit Title", width: 200, flex: 1 },
    { field: "auditType", headerName: "Type", width: 120 },
    { field: "auditor", headerName: "Auditor", width: 150 },
    {
      field: "scheduledDate",
      headerName: "Scheduled Date",
      width: 130,
      valueFormatter: (value) => value ? parseLocalDate(value).toLocaleDateString() : "N/A",
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        <Chip
          icon={getStatusIcon(params.value)}
          label={params.value?.replace("_", " ")}
          color={getStatusColor(params.value)}
          size="small"
        />
      ),
    },
    {
      field: "score",
      headerName: "Score",
      width: 80,
      renderCell: (params) => params.value ? `${params.value}%` : "-",
    },
  ];

  return (
    <MDBox pt={3} py={3} px={2} height={400}>
      <DataGrid
        rows={audits || []}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20, 50]}
        loading={isLoading}
        disableSelectionOnClick
        getRowId={(row) => row.id || row.auditId}
      />
    </MDBox>
  );
};

AuditDataGrid.propTypes = {
  audits: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  showActions: PropTypes.bool,
};

export default AuditDataGrid;

